/**
 * Privacy policy text — bilingual (AR + EN).
 *
 * Versioning: increment `PRIVACY_POLICY_VERSION` (also in
 * /app/backend/routes/auth.py) when any clause materially changes —
 * users will be re-prompted for consent.
 */

export const PRIVACY_POLICY_VERSION = '1.0';

export const PRIVACY_POLICY = {
  ar: {
    title: 'سياسة الخصوصية وحماية البيانات',
    subtitle: 'شركة مركز لوسنت للأسنان · الإصدار 1.0',
    intro:
      'نلتزم في شركة مركز لوسنت للأسنان بحماية خصوصيتك. توضح هذه السياسة كيف نجمع ونستخدم ونحمي بياناتك الشخصية كموظف، وفقاً لنظام حماية البيانات الشخصية في المملكة العربية السعودية (PDPL).',
    clauses: [
      {
        title: 'البيانات التي نجمعها',
        items: [
          'بيانات الهوية: الاسم، رقم الهوية/الإقامة، تاريخ الميلاد، الجنسية.',
          'بيانات الاتصال: البريد الإلكتروني، رقم الجوال، العنوان.',
          'بيانات وظيفية: المسمى الوظيفي، القسم، الراتب، تاريخ التعيين.',
          'بيانات الحضور: أوقات البصمة، الموقع الجغرافي عند البصمة، معرّف الجهاز.',
          'بيانات الإجازات والمخالصات والرواتب.',
          'مستندات العمل: نسخ الهوية، الإقامة، رخصة المزاولة، الشهادات.',
        ],
      },
      {
        title: 'الغرض من معالجة البيانات',
        items: [
          'إدارة علاقتك الوظيفية مع المنشأة.',
          'احتساب الرواتب والمكافآت والإجازات والمخالصات.',
          'التحقق من الحضور والانصراف ومنع التحايل (Anti-Buddy Punching).',
          'التواصل عبر البريد الإلكتروني للإشعارات الرسمية.',
          'الامتثال للأنظمة الحكومية (وزارة الموارد البشرية، التأمينات، قوى، مدد، GOSI، الهيئة الصحية).',
          'إصدار الخطابات والشهادات الرسمية.',
        ],
      },
      {
        title: 'مشاركة البيانات',
        body:
          'لا نشارك بياناتك مع أي طرف ثالث إلا في الحالات التالية: الجهات الحكومية المختصة عند الطلب الرسمي، مزودي الخدمات التقنية الموثوقين تحت اتفاقيات سرية صارمة، والجهات القضائية وفق أمر نظامي. لن تُباع بياناتك تحت أي ظرف.',
      },
      {
        title: 'الموقع الجغرافي ومعرّف الجهاز',
        items: [
          'يحتفظ النظام بإحداثيات GPS عند كل بصمة حضور للتحقق من وجودك ضمن نطاق العيادة.',
          'يُسجّل معرّف جهازك (Device ID) لمنع البصمة بالنيابة.',
          'لا يتم تتبع موقعك خارج أوقات البصمة.',
        ],
      },
      {
        title: 'مدة الاحتفاظ بالبيانات',
        items: [
          'بيانات الحضور: سنتان من تاريخ التسجيل.',
          'بيانات الرواتب والإجازات: 10 سنوات (متطلبات نظام العمل السعودي).',
          'بيانات ما بعد نهاية الخدمة: 5 سنوات ثم تُحذف أو تُؤرشف بشكل مجهول الهوية.',
        ],
      },
      {
        title: 'حقوقك',
        items: [
          'الاطلاع على بياناتك الشخصية المخزّنة.',
          'تصحيح أي بيانات غير دقيقة عبر تقديم طلب لإدارة الموارد البشرية.',
          'الاعتراض على معالجة بياناتك في حالات محددة.',
          'حذف بياناتك بعد انتهاء علاقتك الوظيفية (بحدود المتطلبات النظامية).',
          'سحب الموافقة على أي معالجة اختيارية في أي وقت.',
        ],
      },
      {
        title: 'الأمن والحماية',
        items: [
          'جميع البيانات مشفّرة أثناء النقل (TLS/SSL) والتخزين.',
          'الوصول مقيّد بصلاحيات محددة (Role-Based Access Control).',
          'مراقبة سجلات الدخول والتدقيق المستمر.',
          'لا تُشارك كلمة المرور الخاصة بك مع أي شخص.',
        ],
      },
      {
        title: 'مسؤوليات الموظف',
        items: [
          'الحفاظ على سرية بيانات الدخول الخاصة بك.',
          'عدم استخدام النظام لأغراض شخصية أو تجارية.',
          'عدم محاولة الوصول لبيانات موظفين آخرين.',
          'عدم محاولة تجاوز نظام البصمة (Buddy Punching) — يُعتبر مخالفة جسيمة.',
          'إبلاغ الموارد البشرية فوراً عند فقدان جهازك أو الشك في اختراق حسابك.',
        ],
      },
      {
        title: 'تحديث السياسة',
        body:
          'نحتفظ بحق تحديث هذه السياسة. سيتم إشعارك بأي تغيير جوهري عبر البريد الإلكتروني والإشعارات داخل النظام، وقد يُطلب منك إعادة الموافقة.',
      },
      {
        title: 'التواصل والشكاوى',
        body:
          'لأي استفسار حول بياناتك أو ممارسة حقوقك، يرجى التواصل عبر البريد الإلكتروني: hr@lucent.com.sa أو مراجعة إدارة الموارد البشرية مباشرة.',
      },
    ],
    accept_label: 'أوافق على بنود سياسة الخصوصية',
    accept_btn: 'موافق ومتابعة',
    scroll_hint: 'يرجى قراءة جميع البنود حتى النهاية لتفعيل زر الموافقة',
    saving: 'جاري الحفظ…',
  },
  en: {
    title: 'Privacy & Data Protection Policy',
    subtitle: 'Lucent Dental Center · Version 1.0',
    intro:
      'At Lucent Dental Center we are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal data as an employee, in accordance with the Saudi Personal Data Protection Law (PDPL).',
    clauses: [
      {
        title: 'Data We Collect',
        items: [
          'Identity: name, ID/Iqama number, date of birth, nationality.',
          'Contact: email, mobile number, address.',
          'Employment: job title, department, salary, hire date.',
          'Attendance: punch times, GPS location at punch, device ID.',
          'Leaves, clearances and payroll data.',
          'Work documents: ID/Iqama copies, practitioner licence, certificates.',
        ],
      },
      {
        title: 'Purpose of Processing',
        items: [
          'Managing your employment relationship with the clinic.',
          'Calculating salaries, bonuses, leaves and clearances.',
          'Verifying attendance and preventing buddy-punching.',
          'Sending official notifications via email.',
          'Compliance with government systems (MoL, GOSI, Qiwa, Mudad, health regulators).',
          'Issuing official letters and certificates.',
        ],
      },
      {
        title: 'Data Sharing',
        body:
          'We do not share your data with third parties except: competent government bodies upon official request, trusted technical service providers under strict confidentiality agreements, and judicial bodies pursuant to a legal order. Your data will never be sold under any circumstances.',
      },
      {
        title: 'Location & Device ID',
        items: [
          'GPS coordinates are stored at every punch to verify you are within the clinic geofence.',
          'Your device ID is recorded to prevent buddy-punching.',
          'Your location is not tracked outside of punch events.',
        ],
      },
      {
        title: 'Data Retention',
        items: [
          'Attendance data: 2 years from the date of recording.',
          'Payroll & leave data: 10 years (Saudi Labour Law requirement).',
          'Post-employment data: 5 years, then deleted or anonymised.',
        ],
      },
      {
        title: 'Your Rights',
        items: [
          'Access to your stored personal data.',
          'Correction of any inaccurate data via HR.',
          'Objection to processing in specific cases.',
          'Deletion after end of employment (within legal limits).',
          'Withdrawal of consent for any optional processing at any time.',
        ],
      },
      {
        title: 'Security',
        items: [
          'All data is encrypted in transit (TLS/SSL) and at rest.',
          'Access is restricted via Role-Based Access Control.',
          'Continuous monitoring of login logs and audits.',
          'Do not share your password with anyone.',
        ],
      },
      {
        title: 'Employee Responsibilities',
        items: [
          'Keep your login credentials confidential.',
          'Do not use the system for personal or commercial purposes.',
          'Do not attempt to access other employees\' data.',
          'Do not attempt to bypass the punch system (Buddy Punching) — considered a serious violation.',
          'Immediately notify HR if your device is lost or your account is suspected to be compromised.',
        ],
      },
      {
        title: 'Policy Updates',
        body:
          'We reserve the right to update this policy. You will be notified of any material change via email and in-app notification, and may be asked to re-accept.',
      },
      {
        title: 'Contact & Complaints',
        body:
          'For any question about your data or to exercise your rights, please contact us at: hr@lucent.com.sa or visit the HR department directly.',
      },
    ],
    accept_label: 'I agree to the Privacy Policy terms',
    accept_btn: 'Accept & Continue',
    scroll_hint: 'Please scroll through all clauses to enable the accept button',
    saving: 'Saving…',
  },
};
